import type { CreateAsset, AssetLineage } from '../models/project.model';
import { generatedLineageTitle } from './asset-title.util';

export function lineageIdOf(x: CreateAsset): string {
  return x.lineageId ?? x.id;
}
export function versionOf(x: CreateAsset): number {
  return x.versionNumber ?? 1;
}
// createdAt is typed `number` but Firestore may return a Timestamp at runtime (jobs.ts writes serverTimestamp()).
export function millis(x: unknown): number {
  if (typeof x === 'number') return x;
  const t = x as { toMillis?: () => number } | null | undefined;
  return typeof t?.toMillis === 'function' ? t.toMillis() : 0;
}

export function headOf(versions: CreateAsset[]): CreateAsset {
  const flagged = versions.find((v) => v.isHead);
  if (flagged) return flagged;
  return [...versions].sort((a, b) => versionOf(b) - versionOf(a))[0];
}

export function groupIntoLineages(assets: CreateAsset[]): AssetLineage[] {
  const byLineage = new Map<string, CreateAsset[]>();
  for (const asset of assets) {
    const key = lineageIdOf(asset);
    (byLineage.get(key) ?? byLineage.set(key, []).get(key)!).push(asset);
  }
  const lineages: AssetLineage[] = [];
  for (const [lineageId, group] of byLineage) {
    const versions = [...group].sort((a, b) => versionOf(a) - versionOf(b));
    const head = headOf(versions);
    const generatedTitle = generatedLineageTitle(versions);
    lineages.push({
      lineageId,
      type: head.type,
      title: generatedTitle ?? '',
      generatedTitle,
      head,
      versions,
    });
  }
  // newest lineages first, by head.createdAt (number OR Firestore Timestamp)
  return lineages.sort((a, b) => millis(b.head.createdAt) - millis(a.head.createdAt));
}
